import { Sprites } from "../../../utils/Sprites"
import { MakeVideoImages } from "../MakeVideoAssets"
import { MakeVideoSprite } from "../MakeVideoTypes"

export class MakeVideoIntroBandSprite implements MakeVideoSprite {
    active: boolean
    private sprite: Phaser.Sprite
    private tween: Phaser.Tween

    constructor(game: Phaser.Game, group: Phaser.Group, x: number, y: number, tweenX: number, debug: boolean) {
        this.sprite = Sprites.add(game, MakeVideoImages.BAND, {scale: 1.4, group, debug, x, y})
        this.tween = game.add.tween(this.sprite).to({x: tweenX}, 1000, Phaser.Easing.Quadratic.InOut)
        this.active = true
    }

    destroy = () => {
        this.sprite.destroy(true)
        this.active = false
    }

    tweenIn = () => this.tween.start()
}
